import type { ResolverInput, ResolverResult } from './types';

// Reads progress.has_stripe_connected from the parent-fetched get_setup_progress
// snapshot. True when businesses.stripe_connect_charges_enabled = true (set by
// the Stripe Connect webhook once the account is fully active) OR when the user
// explicitly skipped the item via onboarding_answers.setup_guide.items.stripe_connect.
// §1.7.X consolidation removed the per-resolver RPC fetch — see
// SETUP_ITEMS_CONTRACT_v1.md Rule 1.
export async function resolveStripeConnectItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_stripe_connected) return { complete: true, reason: 'stripe connect active' };
  return { complete: false, reason: 'stripe connect not active' };
}
